module.exports = __webpack_public_path__ + "img/api-spec-first-thumbnail-arrow-tc.7cfbbe84.jpg";